import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: '/recommendations',
    name: 'Recommendations',
    component: () => import('@/pages/recommendations/index.vue'),
    meta: { auth: true, layout: 'default' },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login.vue'),
  },
  {
    path: '/auth/shopify-callback',
    name: 'ShopifyCallback',
    component: () => import('@/pages/auth/shopify-callback.vue'),
  },
  {
    path: '/select-store',
    name: 'SelectStore',
    component: () => import('@/pages/select-store.vue'),
  },
  {
    path: '/custom-store/step1',
    name: 'CustomStoreStep1',
    component: () => import('@/pages/custom-store/step1.vue'),
    meta: { auth: false },
  },
  {
    path: '/custom-store/step2',
    name: 'CustomStoreStep2',
    component: () => import('@/pages/custom-store/step2.vue'),
    meta: { auth: false },
  },
  {
    path: '/custom-store/step3',
    name: 'CustomStoreStep3',
    component: () => import('@/pages/custom-store/step3.vue'),
    meta: { auth: false },
  },
  {
    path: '/public/benchmarks',
    name: 'PublicBenchmarks',
    component: () => import('@/pages/benchmarks/public.vue'),
    meta: { auth: false, layout: false },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/errors/404.vue'),
  },
] as RouteRecordRaw[]
